module.exports = "img/list-close.b9b9f76.png";